import { Check, ArrowRight } from 'lucide-react';
import '@/Sections.css';

const PLANS = [
  {
    name: 'KI-Reel',
    price: 'ab €900',
    unit: 'netto',
    tagline: 'Der schnelle Einstieg: ein generiertes Produkt- oder Werbereel.',
    features: [
      '15–20 Sekunden, ein Look',
      'Umsetzung deiner Vorgabe',
      'Ein Format: quer oder hoch',
      'Schnitt, Color Grading & Sound',
      'Nutzungsrechte für Web, Social & Ads',
    ],
    popular: false,
  },
  {
    name: 'KI-Kampagne',
    price: 'ab €2.200',
    unit: 'netto',
    tagline: 'Mehrere Motive für eine durchgängige Kampagne.',
    features: [
      'Konzept & KI-Regie',
      'Mehrere Szenen & Varianten',
      'Bis ca. 60 Sekunden gesamt',
      'Musik mit gültiger Lizenz',
      'Nutzungsrechte für Web, Social & Ads',
    ],
    popular: true,
  },
  {
    name: 'KI-Film / Hybrid',
    price: 'individuell',
    unit: '',
    tagline: 'Musikvideos, Imagefilme und große generative Welten.',
    features: [
      'Durchkomponierter Film',
      'Hybrid: echter Dreh + KI',
      'Voller Post-Workflow',
      'TV-fähige Produktion',
      'Rechte & Formate nach Bedarf',
    ],
    popular: false,
  },
];

export default function Pricing() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="pricing-section" id="preise" data-testid="pricing-section">
      <div className="container">
        <h2 className="section-title" data-testid="pricing-title" data-reveal>Pakete & Preise</h2>
        <p className="section-subtitle" data-reveal>Klare Einstiege ins KI-Video – transparent kalkuliert</p>

        <div className="pricing-grid" data-reveal="stagger">
          {PLANS.map((p) => (
            <div className={`pricing-card ${p.popular ? 'pricing-popular' : ''}`} key={p.name} data-testid={`pricing-${p.name.toLowerCase().replace(/[^a-z]/g, '')}`}>
              {p.popular && <span className="pricing-badge">Beliebteste Wahl</span>}
              <h3>{p.name}</h3>
              <div className="pricing-price">
                {p.price} {p.unit && <span className="pricing-unit">{p.unit}</span>}
              </div>
              <p className="pricing-tagline">{p.tagline}</p>
              <ul className="pricing-features">
                {p.features.map((f) => (
                  <li key={f}><Check size={16} /> {f}</li>
                ))}
              </ul>
              <button className="pricing-cta" data-magnetic="true" onClick={scrollToContact} data-testid={`pricing-cta-${p.name.toLowerCase().replace(/[^a-z]/g, '')}`}>
                Paket anfragen <ArrowRight size={16} />
              </button>
            </div>
          ))}
        </div>
        <p className="pricing-note" data-reveal>
          Alle Preise netto zzgl. USt. TV- & Kino-Ausspielung sowie größere Projekte kalkulieren wir transparent und individuell.
        </p>
      </div>
    </section>
  );
}
